import { Address } from "@opendaw/lib-box";
import { UUID } from "@opendaw/lib-std";
export var EngineAddresses;
(function (EngineAddresses) {
    EngineAddresses.PEAKS = Address.compose(UUID.Lowest).append(0);
    EngineAddresses.SPECTRUM = Address.compose(UUID.Lowest).append(1);
    EngineAddresses.WAVEFORM = Address.compose(UUID.Lowest).append(2);
    EngineAddresses.STEREO = Address.compose(UUID.Lowest).append(3);
    EngineAddresses.GONIO = Address.compose(UUID.Lowest).append(4);
    EngineAddresses.LOUDNESS = Address.compose(UUID.Lowest).append(5);
    EngineAddresses.HEAP = Address.compose(UUID.Lowest).append(6);
})(EngineAddresses || (EngineAddresses = {}));
